import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from '../../utils/Logger';

import { teamUserReports } from './types';

import { requestTeamUserReportsSuccess, requestTeamUserReportsFailure } from './actions';

import reportEntitiesSaga from './reportEntities/sagas';

const logger = new Logger('Saga:UserReport');

export function* requestTeamUserReportsSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.user_report.team_user_reports', { teamIds: action.teamIds }),
    );

    yield put(requestTeamUserReportsSuccess(action.teamIds, response.data));
  } catch (error) {
    logger.info('Failed to fetch team user reports with the following error', error);
    yield put(requestTeamUserReportsFailure(action.teamIds, error));
  }
}

export default function* teamsSaga() {
  return yield all([
    takeLatest(teamUserReports.request, requestTeamUserReportsSaga),
    reportEntitiesSaga(),
  ]);
}
